module.exports = __webpack_public_path__ + "img/cascader.0688d924.svg";